import localDB, { type JsonValue } from '../localDB/localDB';

// In-memory shadow to minimize IndexedDB reads
let cachedEnabled: boolean | null = null;

const COLLECTION = 'cache' as const;
const KEY = 'enabled' as const;

/** Get whether caching is globally enabled. Defaults to false on first use. */
export async function isCacheEnabled(): Promise<boolean> {
  if (cachedEnabled != null) return cachedEnabled;
  try {
    const val = await localDB.get(COLLECTION as any, KEY);
    if (typeof val === 'boolean') {
      cachedEnabled = val;
      return cachedEnabled;
    }
    // initialize default false
    await localDB.set(COLLECTION as any, KEY, false as unknown as JsonValue);
    cachedEnabled = false;
    return false;
  } catch {
    // Fail-safe: if storage fails, treat as disabled
    cachedEnabled = false;
    return false;
  }
}

/** Explicitly set the global cache enabled flag. */
export async function setCacheEnabled(enabled: boolean): Promise<void> {
  cachedEnabled = !!enabled;
  try {
    await localDB.set(COLLECTION as any, KEY, enabled as unknown as JsonValue);
  } catch {
    // ignore persistence errors; in-memory value will still apply
  }
}
